import { Button, Modal } from 'antd';
import React from 'react';

const DeleteModal = ({
  showModal = false,
  setShowModal,
  title,
  deleteEqc,
  mutationId,
  setMutationId,
}) => {
  const handleOk = () => {
    deleteEqc({
      variables: {
        id: mutationId,
      },
    });
    setShowModal(false);
  };

  const handleCancel = () => {
    setMutationId('');
    setShowModal(false);
  };
  return (
    <div id="delete-eqc-modal-wrapper">
      <Modal
        id="delete-eqc-modal"
        maskClosable={false}
        centered
        open={showModal}
        closable={false}
        footer={null}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <h2 id="delete-eqc-modal-title">Remove Checklist</h2>
        <p id="delete-eqc-confirmation-text">
          Are you sure you want to remove {title} Checklist?
        </p>
        <div className="form-buttons">
          <Button
            id="delete-eqc-cancel-btn"
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
          >
            No, Cancel
          </Button>
          <Button
            id="delete-eqc-confirm-btn"
            shape="round"
            type="primary"
            className="save-button"
            onClick={handleOk}
          >
            Yes, Remove
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteModal;
